import Vue from 'vue'
import router from '@router'
import store from '@state/store'
import VueLoading from 'vue-loading-overlay'
import VuePageTransition from 'vue-page-transition'
import { EffectFade, Swiper } from 'swiper'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueJSModal from 'vue-js-modal/dist/index.nocss'
import axios from 'axios'
import VueEvents from 'vue-events'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import VueLogger from 'vuejs-logger'
import App from './app.vue'

// Globally register all `_base`-prefixed components
import '@components/_globals'

// import all plugins
import '@plugins'

// Don't warn about using the dev version of Vue in development.
const isProduction = process.env.NODE_ENV === 'production'
Vue.config.productionTip = isProduction

// setting the global axios headers
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Swiper.use([EffectFade])

// use plugins
Vue.use(VueLogger, {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true,
})
Vue.use(VueEvents)
Vue.use(VueJSModal)
Vue.use(PerfectScrollbar)
Vue.use(VuePageTransition)
Vue.use(VueAwesomeSwiper, {
  effect: 'fade',
  fadeEffect: { crossFade: true },
  speed: 500,
  slidesPerView: 1,
  height: '100%',
  shortSwipes: false,
  allowTouchMove: false,
  mousewheelControl: false,
  keyboardControl: false,
  loop: false,
  autoplay: false,
  grabCursor: false,
  mousewheel: false,
  noSwiping: true,
  preloadImages: true,
  lazy: false,
  spaceBetween: 20,
  preventClicks: false,
})

// global components
Vue.component('Loading', VueLoading)
Vue.component('PerfectScrollbar', PerfectScrollbar)

// global filters
Vue.filter('comma', (val) => {
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
